import { graphql, readInlineData } from "react-relay";

import { section as sectionData } from "~/data";
import type { helpersCheckIsStyleArticle$key } from "~/queries/__generated__/helpersCheckIsStyleArticle.graphql";

export const checkIsStyleArticle = (reference: helpersCheckIsStyleArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersCheckIsStyleArticle on Article @inline {
        sections {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );

  const [firstSectionEntityId, secondSectionEntityId] =
    article?.sections?.flatMap(section => section?.value?.map(value => value?.entityId)) ?? [];

  return (
    firstSectionEntityId === sectionData.magazine.entityId &&
    secondSectionEntityId === sectionData.style.entityId
  );
};
